import { useContext } from "react";
import SPQSContext from "../contexts/SPQSProvider";

const useSPQS = () => {
  return useContext(SPQSContext);
};

export default useSPQS;
